import { render, staticRenderFns } from "./typeSponsorsEdition.vue?vue&type=template&id=79c3002e"
import script from "./typeSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./typeSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports